import React__default from 'react';
import { c as classnames } from '../../../../index-f9fe84d4.js';
import '../../../../_commonjsHelpers-1a7a244d.js';

var ListFilterHeaderItem = function (_a) {
    var children = _a.children, _b = _a.title, title = _b === void 0 ? '' : _b, isActive = _a.isActive, onClick = _a.onClick;
    var listFilterHeaderItemClassNames = classnames('lists-title-row-filter-item', {
        active: isActive,
    });
    return (React__default.createElement("div", { className: listFilterHeaderItemClassNames, onClick: onClick },
        React__default.createElement("p", { className: 'lists-title-row-filter-item-txt', title: title }, children)));
};

export { ListFilterHeaderItem };
